export default __webpack_public_path__ + "static/media/facebook.caf2301f.png";